import React, { Fragment, useState } from "react";
import NoData from "../../Components/Functionality/NoData";
import ActiveCard from "../../Components/UI/Cards/ActiveCard";
import { RenderLoaderSkeleton } from "../../Components/UI/SkeletonLoader";
import { useUserStore } from "../../Context/store";
import { useSubworkspaceStore } from "../../Context/store";
import useDebounce from "../../Services/useDebounce";
import { useGetLostDebates } from "../../Web-Hooks/Profile/use-profile";
import SearchFilter from "./SearchFilter";
import InfiniteScroll from "../../Components/Functionality/InfiniteScrollList";

const DebateLostList = () => {
  const [search, setSearch] = useState("");
  const debouncedSearchTerm = useDebounce(search, 1000);
  const { selectedSubWorkspace, subWorkspaceList } = useSubworkspaceStore();
  const [filter, setFilters] = useState(null);
  const { user: loggedInUser } = useUserStore();
  const subId = filter
    ? filter?.forum?.label !== "All forum"
      ? filter?.forum?.value
      : ""
    : selectedSubWorkspace?.subWorkSpaceId;
  const {
    data,
    isLoading: isLostListLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useGetLostDebates(loggedInUser?.userId, subId, debouncedSearchTerm);

  const LostList = data?.pages?.flatMap((page) => page?.lostList);
  const forumOptions =
    subWorkspaceList?.map((subWorkspace) => {
      return {
        label: subWorkspace.subWorkSpaceName,
        value: subWorkspace.subWorkSpaceId,
      };
    }) || [];

  return (
    <Fragment>
      <div className="h-full flex flex-col gap-5">
        <div className="h-auto flex gap-4 justify-between w-full">
          {" "}
          <SearchFilter
            search={search}
            setSearch={setSearch}
            filters={
              filter || {
                forum: {
                  label: selectedSubWorkspace?.subWorkSpaceName,
                  value: selectedSubWorkspace?.subWorkSpaceId,
                },
              }
            }
            setFilters={setFilters}
            showFilters={["search", "forum"]}
            forumOptions={[...forumOptions]}
          />
        </div>
        <InfiniteScroll
          fetchNextPage={fetchNextPage}
          hasNextPage={hasNextPage}
          isFetchingNextPage={isFetchingNextPage}
          isLoading={isLostListLoading}
        >
          {isLostListLoading && RenderLoaderSkeleton(3, "motion")}
          {LostList?.length === 0 && (
            <NoData
              isNoData={true}
              message={"Your have not won any debate yet"}
              size={"w-full h-[80%]"}
            />
          )}

          {LostList?.map((lost) => (
            <ActiveCard post={lost} key={lost?.debateId} />
          ))}
        </InfiniteScroll>
      </div>
    </Fragment>
  );
};

export default DebateLostList;
